import httpClient from 'shared/lib/httpClient';

export const getBukuTarifLogList = (params, signal) =>
  httpClient
    .get('/super-admin/tariff-books', { params, signal })
    .then((res) => res.data);
